import { FileIcon } from '@commenda/icons';
import { DownloadDocumentType } from '@commenda/types';
import { fileIconMap } from './file-icon-map';
import { EXCEL_EXTENSIONS, IMAGE_EXTENSIONS } from './files/constants';

export function getFileTypeByUrl(url: string): DownloadDocumentType | null {
  if (!url) return null;

  const urlToCheckAgainst = (url || '').toLowerCase(); // This needs to be done because AWS sometimes have .PNG (extension in call caps).

  switch (true) {
    case urlToCheckAgainst.includes('.pdf'):
      return DownloadDocumentType.PDF;
    case urlToCheckAgainst.includes('.docx'):
      return DownloadDocumentType.DOCX;
    case urlToCheckAgainst.includes('.csv'):
      return DownloadDocumentType.CSV;
    case EXCEL_EXTENSIONS.some((ext) => urlToCheckAgainst.includes(`.${ext}`)):
      return DownloadDocumentType.XLSX;
    case IMAGE_EXTENSIONS.some((ext) => urlToCheckAgainst.includes(`.${ext}`)):
      return DownloadDocumentType.IMAGE;
    default:
      return null;
  }
}

export const getFileIcon = (fileName: string) => {
  if (!fileName) return FileIcon;
  const extension = Object.keys(fileIconMap).find((ext) =>
    fileName?.toLowerCase().endsWith(ext)
  );
  return extension ? fileIconMap[extension] : FileIcon;
};

export type FileComponents = {
  name: string | null;
  extension: string | null;
  fileTypeIcon: React.ElementType;
};

export function getFileComponents(
  filename: string | null | undefined
): FileComponents {
  // Handle null, undefined, and non-string inputs
  if (typeof filename !== 'string' || !filename) {
    return { name: null, extension: null, fileTypeIcon: FileIcon };
  }

  // Split the filename by the last dot to separate name and extension
  const lastDotIndex = filename.lastIndexOf('.');

  // Handle cases with no dot or dot at the start/end of the filename
  if (
    lastDotIndex === -1 ||
    lastDotIndex === 0 ||
    lastDotIndex === filename.length - 1
  ) {
    return { name: filename, extension: null, fileTypeIcon: FileIcon };
  }

  const name = filename.slice(0, lastDotIndex);
  const extension = filename.slice(lastDotIndex + 1).split('?')?.[0];

  return { name, extension, fileTypeIcon: getFileIcon(filename) };
}
